// backend gives us only the whole report route, not just the backend domain,
// so we need to cut off the part we don't need
let apiIndex = apiUrl.indexOf('/api/api/');
export let API_URL = apiIndex > 0 ? apiUrl.slice(0, apiUrl.indexOf('/api/api/')) : apiUrl;
export class Utils {
    static downloadText(text, fileName) {
        const file = new Blob(['\uFEFF' + text], { type: 'text/plain' });
        const a = document.createElement("a");
        a.download = fileName;
        a.href = URL.createObjectURL(file);
        a.click();
    }
    static extractText(html) {
        //uses span to avoid things like &nbsp;
        const span = document.createElement('span');
        span.innerHTML = html.replace(/<[^>]+>/g, ' ').replace(/ +/g, ' ');
        return span.innerText.replace(/[\r\n]/g, "");
    }
    ;
    static flatMap(array, map) {
        const result = [];
        for (let a of array)
            result.push(...map(a));
        return result;
    }
    static chooseTranslation(value) {
        if (!value)
            return "";
        if (value[lang])
            return value[lang];
        if (value["00"])
            return value["00"];
        if (value.en)
            return value.en;
        const keys = Object.keys(value);
        if (keys.length > 0)
            return value[keys[0]];
        return "";
    }
    /*

    //newer version
     static async get<T = any>(api: string): Promise<T | null> {
        return fetch(`${API_URL}${api}`, {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        }).then(async response => {
            if (response.status >= 200 && response.status <= 299) {
                return response.json();
            } else {
                throw response;
            }
        });
    }


     */
    static urlify(website) {
        if (website == null)
            return "";
        else if (website.startsWith("http://") || website.startsWith("https://"))
            return website;
        else
            return "https://" + website;
    }
    static async post(api, body) {
        const response = await fetch(`${API_URL}${api}`, {
            method: "POST",
            headers: {
                //'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
                // Include other headers as required
            },
            body,
        }).then(async (response) => {
            if (response.status >= 200 && response.status <= 299) {
                return response.json();
            }
            else {
                let errors;
                try {
                    errors = await response.json();
                }
                catch (e) {
                    errors = null;
                }
                throw { status: response.statusText, message: errors };
            }
        });
        return await response;
    }
    static async get(api) {
        return fetch(`${API_URL}${api}`, {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        }).then(async (response) => {
            if (response.status >= 200 && response.status <= 299) {
                return response.json();
            }
            else {
                throw response;
            }
        });
    }
    static formValueToFormData(formValue) {
        let formData = new FormData();
        for (let k of Object.keys(formValue))
            Utils.appendToFormData(formData, k, formValue[k]);
        return formData;
    }
    static appendToFormData(fd, name, value) {
        if (typeof value === 'object' && value !== null) {
            if (value instanceof File || (value instanceof Blob && 'name' in value)) {
                // Assert the type to include 'name' property
                fd.append(name, value, value.name);
            }
            else if (value instanceof Blob) {
                fd.append(name, value);
            }
            else if (Array.isArray(value)) {
                for (let i = 0; i < value.length; i++) {
                    Utils.appendToFormData(fd, `${name}[${i}]`, value[i]);
                }
            }
            else {
                for (let innerName of Object.keys(value)) {
                    Utils.appendToFormData(fd, `${name}[${innerName}]`, value[innerName]);
                }
            }
        }
        else if (value === true || value === false) {
            fd.append(name, value ? "1" : "0");
        }
        else {
            if (value !== '') {
                fd.append(name, value);
            }
        }
    }
    static getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            const cookiePart = parts.pop(); // pop() might return undefined
            if (cookiePart) {
                return cookiePart.split(';').shift(); // shift() might also return undefined
            }
        }
        return undefined; // Explicit return if cookie is not found
    }
    static formatFileSize(bytes) {
        if (bytes < 1024)
            return bytes + ' bytes';
        else if (bytes < 1048576)
            return (bytes / 1024).toFixed(2) + ' KB';
        else
            return (bytes / 1048576).toFixed(2) + ' MB';
    }
}
